import styled, { css, keyframes } from 'styled-components';
import { Panel } from '@/components/ActionSheet';
import { Grid, Text } from '@simplywallst/ui-core';

export const StyledPanel = styled(Panel)<{ isCompactMode: boolean }>`
  position: block;
  ${({ isCompactMode, theme }) =>
    isCompactMode &&
    css`
      border: 1px solid ${theme.color.spaceGray};
      margin-left: 10px; // to show the box-shadow left
      box-shadow: -10px -10px 10px ${({ theme }) => theme.color.almostBlackRGBA(0.25)},
        10px 10px 10px ${theme.color.almostBlackRGBA(0.1)};
    `}
`;

export const StyledGrid = styled(Grid)<{ isDesktop: boolean }>`
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  padding-top: ${({ theme }) => theme.x2spacePx}px;
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${({ isDesktop, theme }) =>
    css`
      padding-left: ${isDesktop ? theme.x1spacePx : theme.x2spacePx}px;
    `}
`;

export const Ticker = styled(Text)`
  margin-left: ${({ theme }) => theme.x1spacePx}px;
`;

const easeOutCubic = 'cubic-bezier(0.23, 1, 0.32, 1)';

const show = (x: number) => keyframes`
  from {
    transform: translate(calc(${-x}px), 0);
    opacity: 0;
  }
  to {
    transform: translate(0, 0);
    opacity: 1;
  }
`;

const hide = (x: number) => keyframes`
  from {
    transform: translate(0, 0);
    opacity: 1;
  }
  to {
    transform: translate(calc(${-x}px), 0);
    opacity: 0;
  }
`;

export const Animation = styled('div')<{ isEnter: boolean }>`
  display: grid;
  position: absolute;
  width: 100%;
  height: 100%;
  ${({ theme, isEnter }) => {
    const goTo = isEnter ? show : hide;
    return css`
      animation: ${goTo(theme.x10spacePx)} 0.3s ${easeOutCubic} 0s forwards;
    `;
  }}
`;

export const TransitionWrapper = styled('div')`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
`;
